// ColonyActions.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faSearch, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

export default function ColonyActions() {
  return (
    <div className="mb-4 flex flex-wrap gap-3">
      <Link to="/fetch-groups" className="btn btn-outline-primary btn-sm">
        <FontAwesomeIcon icon={faUsers} className="me-2" />
        Find a Community
      </Link>
      <Link to="/user-search" className="btn btn-outline-primary btn-sm">
        <FontAwesomeIcon icon={faSearch} className="me-2" />
        Find a Friend
      </Link>
      <Link to="/post-group" className="btn btn-outline-primary btn-sm">
        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
        Start a Community
      </Link>
    </div>
  );
}
